import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { LoggerService, LogCategory, LogType, LogWidget } from 'src/app/core/services/logger.service';
import { TransferCreditsService } from 'src/app/services/transfer-credits.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../../core/services/profile.service';

//  COMPONENT IS OBSOLETE AND CAN BE REMOVED ONCE THERE ARE NO ACTIVE OLD REQUEST OBJECTS
@Component({
    selector: 'app-edit-request',
    templateUrl: './edit-request-modal.component.html',
    styleUrls: ['./edit-request-modal.component.scss'],
    standalone: false
})
export class EditRequestModalComponent implements OnInit, OnDestroy {

    @Input() requestId: number = 0;
    @Input() request: Observable<any> = null;

    public editRequest$: Observable<any>;
    error = false;
    errorUnauthorized = false;


    constructor(
        private logger: LoggerService,
        public profile: ProfileService,
        public transferCredits: TransferCreditsService,
        public activeModal: NgbActiveModal
    ) {
       
    }
    
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.TransferCredits, category);
    }
    
    ngOnDestroy(): void {
        this.log("ngOnDestroy", "", LogCategory.Destroy);
    }

    ngOnInit(): void {       
        this.log("ngOnInit", null, LogCategory.Init);
        let requestToEdit$: Observable<any>;
        if (this.requestId > 0) {
            //this.transferCredits.request$.next(this.requestId);
            requestToEdit$ = this.transferCredits.fetchMyRequest$(this.requestId);
        }
            
        if (this.request != null)
            requestToEdit$ = this.request;


        this.editRequest$ = requestToEdit$.pipe(
            catchError(err => {
                this.error = true;
                if (err.status == 401) {
                    this.errorUnauthorized = true;
                }
                return throwError(err);
            })
        );
    }
}
